import React, { FC } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { TDropdownProps } from '../../types/PrivacyStatement.types';
import {windowService} from '../../../../utils/window.utils';

const Dropdown: FC<TDropdownProps> = (props: TDropdownProps) => {
    const { languageCollection, changeLanguageTitle, languageTitle } = props;
    const navigate = useNavigate();
    const location = useLocation();

    const updateUrlQueryStringParams = (language: string): void => {
        const getQuery = () => new URLSearchParams(windowService().location?.search);
        const queries = getQuery();

        const updateUrlParams = (key, newVal: string) => {
            if (newVal.trim() !== '') {
                queries.set(key, newVal);
            } else {
                queries.delete(key);
            }
        };

        updateUrlParams('lng', language);
        navigate(`${location.pathname}?${queries.toString()}`);
        windowService()?.location.reload();
    };

    return (
        <div className='privacy-statement__dropdown-wrapper'>
            <span className='privacy-statement__dropdown-title'>{changeLanguageTitle}</span>
            <select className='privacy-statement__dropdown' onChange={(e) => updateUrlQueryStringParams(e.target.value)}>
                {
                    languageCollection.map((lang) => {
                        const key = Object.keys(lang)[0];
                        const value = Object.values(lang)[0];
                        return (
                            <option value={key} key={key} selected={languageTitle === value}>
                                {value}
                            </option>
                        )
                    })
                }
            </select>
        </div>
    )
}

export default Dropdown;
